export const SCROLL_VISIBILITY_BOUNDRY = 10;
